import ToolTip from "components/design/toolTip";
import { Button } from "components/DesignSystem/Button/Button";
import { Cross } from "components/icons/Cross";
import { CHAT_FILTERS_NUDGE_TEXT } from "constants/chatFilterNudge";
import { colors } from "constants/colors";
import { useChatFilterNudge } from "hooks/useChatFilterNudge";
import { ComponentProps, forwardRef, Ref } from "react";

type ChatFilterNudgeProps = ComponentProps<"div">;

export const ChatFilterNudge = forwardRef(
  (
    { children, ...triggerProps }: ChatFilterNudgeProps,
    ref: Ref<HTMLDivElement>
  ) => {
    const { isUnseen, markSeen } = useChatFilterNudge();

    const handleDismiss = () => {
      void markSeen();
    };

    const trigger = (
      <div className="t-relative" ref={ref} {...triggerProps}>
        {children}
        {/* Straddles the pill's top edge just inside its right one, as the
            design places it. */}
        {isUnseen && (
          <span className="t-pointer-events-none t-absolute -t-right-px -t-top-0.5 t-size-1.5">
            <span className="t-absolute t-inset-0 t-animate-overdue-pulse t-rounded-full t-bg-purple motion-reduce:t-animate-none" />
            <span className="t-absolute t-inset-0 t-rounded-full t-bg-purple" />
          </span>
        )}
      </div>
    );

    if (!isUnseen) {
      return trigger;
    }

    const hintContent = (
      <div className="t-flex t-items-center t-gap-4 t-text-left">
        <span className="t-text-body-sm t-font-light">
          {CHAT_FILTERS_NUDGE_TEXT}
        </span>
        <Button customType="link_neutral" onClick={handleDismiss} size="xsmall">
          <Cross color={colors.white} size="14" />
        </Button>
      </div>
    );

    return (
      <ToolTip
        open
        propClass="t-w-64"
        side="right"
        sideOffset={12}
        text={hintContent}
      >
        {trigger}
      </ToolTip>
    );
  }
);
